<div mat-dialog-title>
	Version {{ data.versionNumber }} vs. current
</div>

<mat-dialog-content>
	<section class="mb-3">
		<label class="font-weight-bold mb-1">Subject</label>
		<div *ngIf="!subjectChanged" class="text-muted">Unchanged</div>
		<div *ngIf="subjectChanged" class="diff-block">
			<div class="diff-line remove">- {{ data.oldSubject }}</div>
			<div class="diff-line add">+ {{ data.newSubject }}</div>
		</div>
	</section>

	<section>
		<label class="font-weight-bold mb-1">Body</label>
		<div class="diff-block">
			<div *ngFor="let line of bodyDiff" class="diff-line" [ngClass]="line.type">
				<span class="diff-marker">{{ line.type === 'add' ? '+' : line.type === 'remove' ? '-' : ' ' }}</span>{{ line.text }}
			</div>
		</div>
	</section>
</mat-dialog-content>

<mat-dialog-actions>
	<button class="btn btn-link" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
